<app-barra-superior></app-barra-superior>
<app-cabecalho-barra-lateral></app-cabecalho-barra-lateral>
<app-cabecalho></app-cabecalho>
<router-outlet></router-outlet>
<app-botao-scroll class="align-top p-d-inline-block" *ngIf="mostrarBotaoScroll" #botaoScroll (click)="botaoScroll.scrollTop()" [rodapeVisivel]='rodapeVisivel'></app-botao-scroll>
<app-rodape (isVisibleEvent)="onRodapeVisibilityChange($event.valueOf())" (mapaEvent)="mapaToggle($event.valueOf())"></app-rodape>
<app-mapa-site (mapaEvent)="mapaToggle($event.valueOf())" *ngIf="exibirMapa" id="mapa"></app-mapa-site>
<app-chat></app-chat>
<app-cookies></app-cookies>
